import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { applyConsent } from '@/lib/consent';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Portfolio from '@/pages/Portfolio';
import ProjectDetail from '@/pages/ProjectDetail';
import Units from '@/pages/Units';
import UnitDetail from '@/pages/UnitDetail';
import Services from '@/pages/Services';
import News from '@/pages/News';
import NewsDetail from '@/pages/NewsDetail';
import Blogs from '@/pages/Blogs';
import BlogDetail from '@/pages/BlogDetail';
import Contact from '@/pages/Contact';
import Privacy from '@/pages/Privacy';
import CookiePolicy from '@/pages/CookiePolicy';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import GAListener from '@/components/GAListener';
import AIChatbot from '@/components/AIChatbot';
import CookieConsent from '@/components/CookieConsent';

// Admin Pages
import Login from '@/pages/admin/Login';
import AdminLayout from '@/pages/admin/AdminLayout';
import Dashboard from '@/pages/admin/Dashboard';
import PortfolioManagement from '@/pages/admin/PortfolioManagement';
import UnitsManagement from '@/pages/admin/UnitsManagement';
import LeadsManagement from '@/pages/admin/LeadsManagement';
import NewsManagement from '@/pages/admin/NewsManagement';
import BlogsManagement from '@/pages/admin/BlogsManagement';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    // Hydrate analytics ONLY if the user has previously consented
    applyConsent();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <GAListener />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Navigation />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navigation />
              <About />
              <Footer />
            </>
          } />
          <Route path="/portfolio" element={
            <>
              <Navigation />
              <Portfolio />
              <Footer />
            </>
          } />
          <Route path="/portfolio/:id" element={
            <>
              <Navigation />
              <ProjectDetail />
              <Footer />
            </>
          } />
          <Route path="/units" element={
            <>
              <Navigation />
              <Units />
              <Footer />
            </>
          } />
          <Route path="/units/:id" element={
            <>
              <Navigation />
              <UnitDetail />
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Navigation />
              <Services />
              <Footer />
            </>
          } />
          <Route path="/news" element={
            <>
              <Navigation />
              <News />
              <Footer />
            </>
          } />
          <Route path="/news/:id" element={
            <>
              <Navigation />
              <NewsDetail />
              <Footer />
            </>
          } />
          <Route path="/blogs" element={
            <>
              <Navigation />
              <Blogs />
              <Footer />
            </>
          } />
          <Route path="/blogs/:id" element={
            <>
              <Navigation />
              <BlogDetail />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Navigation />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/privacy" element={
            <>
              <Navigation />
              <Privacy />
              <Footer />
            </>
          } />
          <Route path="/cookies" element={
            <>
              <Navigation />
              <CookiePolicy />
              <Footer />
            </>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="portfolio" element={<PortfolioManagement />} />
            <Route path="units" element={<UnitsManagement />} />
            <Route path="leads" element={<LeadsManagement />} />
            <Route path="news" element={<NewsManagement />} />
            <Route path="blogs" element={<BlogsManagement />} />
          </Route>
        </Routes>
        {/* Cookie Consent Banner - blocks tracking until user consents */}
        <CookieConsent />
      </BrowserRouter>
      
      {/* AI Chatbot - Available on all pages */}
      <AIChatbot />
    </div>
  );
}

export default App;
